import {TransformingSmilesImg}  from '../../../../../images/index'

export default function TransformingSmilesSlideV2() {
  
  return (
    <div className="relative h-screen flex flex-col-reverse">
      <div className="h-1/2 lg:h-full w-full bg-bgDark lg:bg-none  flex flex-col justify-center text-center  lg:w-1/2 lg:text-left ">
        <div className="z-10 px-4 max-w-2xl mx-auto sm:px-8 pb-12 md:pb-20 lg:pt-0">
          <h1 className="text-center lg:text-left text-white text-2xl sm:text-3xl lg:text-4xl font-semibold">
            Transforming smiles with precision
          </h1>
          <p className="mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
            <h2 className="text-center lg:text-left text-xl font-sans text-gray-400 my-2">
              Welcome to XiViX, the future of dentistry.
            </h2>
            <div className="my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-gray-300" />
            <p className="text-center lg:text-left text-white my-1">
              A platform where Cosmetic Dentistry is Digitised, Smiles are
              Transformed and Single Visit Dentistry is made possible.
            </p>
          </p>
        </div>
      </div>
      <div className="relative h-2/3 lg:absolute lg:inset-y-0 lg:right-0 lg:w-full lg:h-full z-0">
        <img
          className="absolute inset-0 pt-12 lg:pt-0 object-cover w-full h-full"
          src={TransformingSmilesImg}
          alt=""
        />
      </div>
    </div>
  );
}
